<template>
  <div class="custom-tree-container">
    <div class="content-bottom-padded">
      <el-alert type="info" title="操作说明" show-icon >
        <div> 说明：该数据来源于商城，仅供排序操作。 </div>
      </el-alert>
    </div>
    <el-row class="content-bottom-padded" style="padding-top:15px;margin-left:20px">
      <el-col>
        <el-button type="primary" icon="plus" @click="updateAreaManage" size="mini" :disabled="isDisable">保存修改</el-button>
        <el-button type="warning" icon="plus" @click="newList" size="mini" >数据同步</el-button>
      </el-col>
    </el-row>

    <div class="block">
      <ul class="custom-tree-node-title">
        <li>Id</li>
        <li>地区名称</li>
        <li>地区经理</li>
        <li>经理电话</li>
        <li>排序</li>
        <li>操作</li>
      </ul>
    </div>
    <div class="tree-background block">

      <el-tree v-loading="loading" :data="areamanageList" default-expand-all :expand-on-click-node="false">
        <ul class="custom-tree-node" slot-scope="{ node, data }">
          <li>{{data.area_id}}</li>
          <li>
            <input placeholder="区域名称"  disabled="true" readonly v-model="data.name"/>
            <el-button type="text" v-if="data.sort == 1 || data.sort == 2" @click="append(data.children, data.sort)">新增子区域</el-button>
          </li>
          <li>{{data.manager_name }}</li>
          <li>{{data.manager_mobile}}</li>
         <li>
            <span style="padding-right:100px"><input style="width:50px" placeholder="排序" v-model="data.sort"/></span>
         </li>
        <li>
            <span class="remove-category" @click="deleteCategory(node, data)">
              <i class="iconfont icon-trash-alt"></i>
            </span>
        </li>
        </ul>
      </el-tree>
      <div class="add-category">
        <span @click="append(areamanageList)"><i class="el-icon-plus"></i>新增区域</span>
      </div>
    </div>

  </div>
</template>
<script>
import {getAreaManageList, saveAreaManage, updateAreaManage, deleteAreaManage,newDataAreaManage} from '../../api/areamanage'

export default {
  components: {
  },
  data() {
    return {
      isDisable: false,
      loading: false,
      spaceInput: false,
      areamanageList: [],
      total_count: 0,
      attrParams: {
        page: 1,
        pageSize: 20,
      },
      params: [],
      dialogLoading: false,
      relAttrvisible: false,
      goodsAttr: [],
      checkGoodsAttr: [],
      currentNode: 0,
      currentAttrType: '',
      goodsAttrTotal: 0,
      currentList: []
    }
  },
  methods: {
    handleCurrentChange (page) {
      this.attrParams.page = page
      this.getGoodsAttr()
    },
    handleSizeChange (pageSize) {
      this.attrParams.page = 1
      this.attrParams.pageSize = pageSize
      this.getGoodsAttr()
    },
    handleDialogAttr(data, type, node) {
      this.dialogLoading = true
      this.relAttrvisible = true
      this.currentAttrType = type
      this.currentNode = node
      this.currentList = data
      this.attrParams.page = 1
      this.attrParams.pageSize = 20

    },
    selectAll(data) {
      this.$message({ type: 'error', message: '绑定不支持全选' })
      this.toggleRowSelection()
    },
    toggleRowSelection() {
      this.$refs.multipleTable.clearSelection();

      var checkids = []
      this.checkGoodsAttr.forEach(item => {
        checkids.push(item.attribute_id)
      })

      this.goodsAttr.forEach(item => {
        if (checkids && checkids.indexOf(item.attribute_id) !== -1) {
          this.$refs.multipleTable.toggleRowSelection(item)
        }
      })
    },
    handleSelectionChange (val, row) {
      var findIndex = -1
      var visible = 1
      this.checkGoodsAttr.forEach((item, index) => {
        // 如果操作的数据在已选择中，则表示取消选择
        if (row.attribute_id == item.attribute_id) {
          findIndex = index
        } else {
          if (item.is_image === 'true' && row.is_image === 'true') {
            this.$message({ type: 'error', message: '只能绑定一个图片类型规格' })
            this.toggleRowSelection()
            visible = 0
          }
        }
      })

      if (!visible) {
        this.toggleRowSelection()
        return false
      }

      if (this.currentAttrType == 'item_params') {
        if (this.checkGoodsAttr.length >= 20 && findIndex == -1) {
          this.toggleRowSelection()
          this.$message({ type: 'error', message: '最多关联20个商品参数' })
          return false
        }
      } else {
        if (this.checkGoodsAttr.length >= 3 && findIndex == -1) {
          this.toggleRowSelection()
          this.$message({ type: 'error', message: '最多关联3个规格' })
          return false
        }
      }

      if (findIndex != -1) {
        this.checkGoodsAttr.splice(findIndex, 1)
      } else {
        this.checkGoodsAttr.push(row)
      }
    },
    async getGoodsAttr(checkids=[]) {
      if(checkids.length === 0) {
        this.checkGoodsAttr.forEach(item => {
          checkids.push(item.attribute_id)
        })
      }

      if (checkids.length > 0) {
        await getGoodsAttr({page: 1, pageSize: 100, attribute_type: this.currentAttrType, attribute_ids: checkids}).then(info => {
          this.checkGoodsAttr = info.data.data.list
        })
      }

      await getGoodsAttr({page: this.attrParams.page, pageSize: this.attrParams.pageSize, attribute_type: this.currentAttrType}).then(res => {
        this.goodsAttr = res.data.data.list
        this.goodsAttrTotal = res.data.data.total_count
      })

      this.goodsAttr.forEach(item => {
        if (checkids && checkids.indexOf(item.attribute_id) !== -1) {
          this.$refs.multipleTable.toggleRowSelection(item)
        }
      })
      this.dialogLoading = false
    },

    handleCancel () {
      this.relAttrvisible = false
      this.dialogLoading = false
      this.attrParams.page = 1
      this.attrParams.pageSize = 20
      this.goodsAttr = []
      this.checkGoodsAttr = []
      this.currentAttrType = ''
      this.currentList = []
    },
    getAreaManageList() {
      this.loading = true
      getAreaManageList(this.params).then(response => {
        this.areamanageList = response.data.data
        this.loading = false
        this.spaceInput = false
      })
    },
    updateAreaManage() {
      for (var i = 0; i < this.areamanageList.length; i++) {
        for (var a = 0; a < this.areamanageList.length - 1 - i; a++) {
          if(this.areamanageList[a].name == this.areamanageList[a+1].name) {
            this.$message({
              type: 'error',
              message: '同级区域名称不能相同'
            })
            return false
          }
        }

        if (!this.catNameCheck(this.areamanageList[i].name)) {
          return false
        }

        for (var j = 0; j < this.areamanageList[i].children.length; j++) {
          for (var b = 0; b < this.areamanageList[i].children.length - 1 - j; b++) {
            if(this.areamanageList[i].children[b].name == this.areamanageList[i].children[b+1].name) {
              this.$message({
                type: 'error',
                message: '同级区域名称不能相同'
              })
              return false
            }
          }
          if (!this.catNameCheck(this.areamanageList[i].children[j].name)) {
            return false
          }
        }
      }
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false
      }, 1000)
      let form = JSON.stringify(this.areamanageList)
      saveAreaManage({form: form}).then(response => {
        this.$message({
          type: 'success',
          message: '保存成功'
        })
        this.getAreaManageList()
      })
    },
    deleteCategory(node, data) {
      this.noUse();
      return false;
      this.$confirm('此操作将删除该区域, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (typeof (data.area_id) != 'undefined') {
          deleteAreaManage(data.area_id).then(response => {
            this.$message({
              type: 'success',
              message: '删除区域成功'
            })
            this.getAreaManageList()
          })
        } else {
          const parent = node.parent;
          const children = parent.data.children || parent.data;
          const index = children.findIndex(d => d.id === data.id);
          children.splice(index, 1);
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    newList(){
      this.$confirm('此操作将更新同步数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'warning',
          message: '正在同步,请稍后!',
          duration:3000,
        })
        newDataAreaManage().then(response => {
          this.$message({
            type: 'success',
            message: '同步成功了！'

          })
          this.getAreaManageList()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })

    },
    noUse(){
      this.$message({
        type: 'info',
        message: '该功能已被禁用'
      })
      return false;
    },
    append(data, sort= 0) {
      this.noUse();return false;
      var new_sort = sort + 1
      const newChild = {name: '', sort: 0, sort: new_sort, children: [], created: -1}
      data.push(newChild)
    },
    catNameCheck (catName) {
      let catNameLength = 0
      if(catName) {
        for (var i=0; i < catName.length; i++) {
          if (catName.charCodeAt(i) > 255) {
            catNameLength += 2;
          } else {
            catNameLength ++ ;
          }
        }
        if(catNameLength > 50) {
          this.$message({
            type: 'error',
            message: '区域名称长度最多25个汉字或50个字符'
          })
          return false
        }
        return true
      } else {
        this.$message({
          type: 'error',
          message: '区域名称不能为空'
        })
        return false
      }
    },

  },

  mounted() {
    this.getAreaManageList()
  }
};
</script>

<style scoped lang="scss">

.sku-value {
  margin-right: 10px;
}

.custom-tree-container {
  background-color: #fff;
}

.tree-background {
  padding-bottom: 45px;
  margin: 0px 20px;
}

.custom-tree-node, .custom-tree-node-title {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  li {
    display: inline-block;
    text-align: center;
    width: 25%;
  }
  li:first-child {
    text-align: left;
  }
  li.category-icon {
    display: flex;
    align-items: middle;
    justify-content: center;
    span {
      height: 30px;
    }
    img {
      width: auto;
      height: 30px;
    }
  }
}

.custom-tree-node-title {
  font-weight: bold;
  color: #909399;
  margin: 0px 20px;
  li {
    padding: 12px 0;
  }
}

.add-category {
  margin-left: 25px;
  margin-top: 30px;
  span {
    cursor: pointer;
  }
}

.remove-category {
  margin-left: 10px;
}

.add-child-category {
  margin-left: 10px;
}
</style>
<style lang="scss">
.custom-tree-container {
  .el-tree-node__content{
    height: 45px;
    padding: 0px;
    line-height: 45px;
  }
  .el-tree > .el-tree-node {
    position: relative;
    &::after {
      position: absolute;
      height: 1px;
      left: 0;
      right: 0;
      bottom: 0;
      content: "";
      background-color: #e6e6e6;
    }
  }
  .el-tree > .el-tree-node:first-child {
    &::before {
      position: absolute;
      height: 1px;
      left: 0;
      right: 0;
      top: 0;
      content: "";
      background-color: #e6e6e6;
    }
  }
}

.custom-tree-node {
  input {
    border: 1px solid #ddd;
    line-height: 25px;
    padding-left: 5px;
    width: 150px;
  }
}

</style>



// WEBPACK FOOTER //
// list.vue?6c9dca08